// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconGridViewModePath = 'M5.8 17.5c.4 0 .7-.3.7-.7V3.3c0-.5-.3-.8-.7-.8H2.2c-.4 0-.7.3-.7.8v13.5c0 .4.3.7.7.7h3.6Zm0 1.5H2.2C1 19 0 18 0 16.8V3.3C0 2 1 1 2.2 1h3.6C7 1 8 2 8 3.3v13.5C8 18 7 19 5.8 19ZM17.8 7.5c.4 0 .7-.3.7-.7V3.3c0-.5-.3-.8-.7-.8h-5.5c-.5 0-.8.3-.8.8v3.5c0 .4.3.7.8.7h5.5Zm0 1.5h-5.5C11 9 10 8 10 6.8V3.3C10 2 11 1 12.3 1h5.5C19 1 20 2 20 3.3v3.5C20 8 19 9 17.8 9ZM17.8 17.5c.4 0 .7-.3.7-.7v-3.5c0-.5-.3-.8-.7-.8h-5.5c-.5 0-.8.3-.8.8v3.5c0 .4.3.7.8.7h5.5Zm0 1.5h-5.5C11 19 10 18 10 16.8v-3.5c0-1.3 1-2.3 2.3-2.3h5.5c1.2 0 2.2 1 2.2 2.3v3.5c0 1.2-1 2.2-2.2 2.2Z';
var IconGridViewMode = baseIcon('IconGridViewMode', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconGridViewModePath
});
export default IconGridViewMode;
//# sourceMappingURL=index.js.map